/** Play listing previews only when a meaningful share of the card is visible. */
export const BRAND_KIT_PREVIEW_VISIBLE_RATIO = 0.4;

export function shouldPlayVisibleBrandKitPreview(entry: {
  isIntersecting: boolean;
  intersectionRatio: number;
}): boolean {
  return entry.isIntersecting && entry.intersectionRatio >= BRAND_KIT_PREVIEW_VISIBLE_RATIO;
}
